import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './styles/naive-ui-fix.css'
import './styles/main.css'
import { useAppStore } from './stores/app'

// 低端/旧浏览器兜底：naive-ui 依赖 ResizeObserver/IntersectionObserver，缺失会导致组件渲染失败
import ResizeObserverPolyfill from 'resize-observer-polyfill'
import 'intersection-observer'
if (typeof window !== 'undefined' && !(window as any).ResizeObserver) {
  ;(window as any).ResizeObserver = ResizeObserverPolyfill
}

// 全局注册 Naive UI 组件（用于调试）
import {
  NConfigProvider,
  NMessageProvider,
  NInput,
  NButton,
  NForm,
  NFormItem,
  NCheckbox
} from 'naive-ui'

// Create Vue app
const app = createApp(App)

// 全局注册 Naive UI 组件
app.component('NInput', NInput)
app.component('NButton', NButton)
app.component('NForm', NForm)
app.component('NFormItem', NFormItem)
app.component('NCheckbox', NCheckbox)
app.component('NConfigProvider', NConfigProvider)
app.component('NMessageProvider', NMessageProvider)

// Create Pinia instance
const pinia = createPinia()

// Install plugins
app.use(pinia)
app.use(router)

// Initialize stores after Pinia is installed
const appStore = useAppStore()

appStore.initTheme()

// 初始化：检查并清理无效的token
const initAuth = () => {
  const token = localStorage.getItem('token')
  const userInfo = localStorage.getItem('userInfo')
  
  // 如果有token但没有userInfo，说明数据不完整，清除token
  if (token && !userInfo) {
    console.warn('检测到不完整的认证数据，已清除')
    localStorage.removeItem('token')
  }
  
  // 如果有userInfo但没有token，说明数据不完整，清除userInfo
  if (!token && userInfo) {
    console.warn('检测到不完整的用户数据，已清除')
    localStorage.removeItem('userInfo')
  }
}

// 执行初始化
initAuth()

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('Global error:', err)
  console.error('Error info:', info)
  console.error('Component instance:', instance)
  
  // You can send error to logging service here
  // Example: logErrorToService(err, info)
}

// Global warning handler
app.config.warnHandler = (msg, _instance, trace) => {
  console.warn('Global warning:', msg)
  console.warn('Warning trace:', trace)
}

// Mount app
app.mount('#app')
